import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { Globals } from '../globals';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  globals: Globals;
  mobileMenuOpen = false;

  constructor(
    globals: Globals,
    public translate: TranslateService,
    private titleService: Title,
    private changeDetector: ChangeDetectorRef
  ) {
    translate.addLangs(['en', 'ie']);
    translate.setDefaultLang('en');

    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|ie/) ? browserLang : 'en');

    translate.onLangChange.subscribe((event) => {
      globals.blLanguage = (event.lang == 'en') ? 0 : 1;
      translate.get('COMMON.PAGE_TITLE').subscribe((res: string) => {
        titleService.setTitle(res);
        this.changeDetector.detectChanges();
        this.changeDetector.markForCheck();
      });
    });
  }

  ngOnInit() {
  }

  toggleMobileMenu() {
    document.getElementById("mobile-nav").style.display = this.mobileMenuOpen ? "none" : "block";
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

}
